/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_TeamInputs */

const en_case_detail_team = /** @type {(inputs: Case_Detail_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const pt_br2_case_detail_team = /** @type {(inputs: Case_Detail_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipe`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Case_Detail_TeamInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_team = /** @type {((inputs?: Case_Detail_TeamInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_TeamInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_team(inputs)
	return pt_br2_case_detail_team(inputs)
});